import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Field } from 'redux-form';
import styles from './phoneNumber.module.scss';
export const MATCH_FIELD = 'match';
export function PhoneNumber({ field, index, isOnlyNumber, onPhoneNumberRemove, onRemove, }) {
    const handleRemove = useCallback(() => {
        onRemove(index);
        onPhoneNumberRemove();
    }, [index, onPhoneNumberRemove, onRemove]);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Field, { component: FieldText, label: `Phone number #${index + 1}`, name: `${field}.${MATCH_FIELD}`, placeholder: "Phone number (e.g. +12058321080 or +1)" }), _jsx(IconButton, { className: styles.trashButton, disabled: isOnlyNumber, icon: "trash", onClick: handleRemove, type: "button", variant: "tertiary" })] })));
}
